const testimonials = [
  {
    id: 1,
    desc: "Shreem hospital is one of the best hospital for any orthopedic or eye condition in Vadodara. The doctors and staff are very helpful and kind to everyone. They are keeping care of every patient very personally that feels like home in hospital. The atmosphere is very calm and positive. I prefer everyone to visit hospital.",
    name: "Nidhi Mistry",
  },
  {
    id: 2,
    desc: "Shreem Hospital is a very well-maintained hospital and trained staff. I went there for dressing as it was nearby to my house and received a prompt service from the doctors even on Sunday. It is a relief for the people in this locality as I haven't seen such a good behaviour from any hospitals nearb especially on a holiday.",
    name: "Harsh Shah",
  },
  {
    id: 3,
    desc: "We got our mom treated by Dr. Anshul Dave when she had a fracture in her leg. I still remember that day when we went to several hospitals because of my mom's fracture and when we went to him, his way of guiding us impressed us a lot and he provided us all the treatment and service very well during those difficult times. ",
    name: "Kajal Lalwani",
  },
  {
    id: 4,
    desc: "I recently visited and was thoroughly impressed with the exceptional care I received. The facilities were modern, clean, and well-maintained. The staff were courteous, attentive, and highly professional. Dr.Anshul Dave, demonstrated outstanding expertise and compassion. He provided clear guidance throughout my stay.",
    name: "Vishal Dantara",
  },
];

export default testimonials;
